import _ from 'lodash';
import React, { Component } from 'react';
import { Search } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { encodeClubUrl } from '../../../helpers/clubHelper';

export default class ClubSearchView extends Component {
  componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () => {
    this.setState({ isLoading: false, results: [], value: '' });
  };

  handleResultSelect = (e, result) => {
    // TODO: Redirect to club page
    this.setState({ value: result.title });
  };

  handleSearchChange = (e, searchObj) => {
    const value = typeof searchObj === 'object' ? searchObj.value : searchObj;
    var search = { query: { $sort: { name: 1 } } };
    if (!search.query['$or']) {
      search.query['$or'] = [];
    }

    search.query['$or'].push({
      name: { $regex: value, $options: 'i' }
    });
    search.query['$or'].push({
      city: { $regex: value, $options: 'i' }
    });
    search.query['$or'].push({
      state: { $regex: value, $options: 'i' }
    });
    search.query['$or'].push({
      country: { $regex: value, $options: 'i' }
    });

    this.props.requestSearchClubs(search);

    this.setState({ isLoading: true, value });

    setTimeout(() => {
      if (this.state.value && this.state.value.length < 1) {
        return this.resetComponent();
      }

      const source = _.map(this.props.clubs, club => {
        return {
          title: `${club.name} (${club.city})`,
          description: `${club.city} - ${club.state} - ${club.country}`,
          image: club.img || '/img/crest.svg',
          href: encodeClubUrl(club)
        };
      });

      this.setState({
        isLoading: false,
        results: source
      });
    }, 500);
  };

  render() {
    const { isLoading, value, results } = this.state;
    return (
      <Search
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        results={results}
        value={value}
        aligned="right"
        placeholder="Search..."
        minCharacters={2}
      />
    );
  }
}

ClubSearchView.defaultProps = {
  requestSearchClubs: () => ({}),
  clubs: []
};

ClubSearchView.propTypes = {
  requestSearchClubs: PropTypes.func,
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired
    })
  )
};



// WEBPACK FOOTER //
// ./src/components/Search/Navbar/ClubSearchView.js